import * as React from 'react';
import { useRef,  } from 'react'
import {gold, white, black, fontBrand } from '../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import { Stack, } from "@mui/material";
import Container from '@mui/material/Container';
import { Box, } from "@mui/material";
import MapContainer from './mapContainer'

interface Props {
  ubication: string;
  height: string;
  width: string;
  zoom: number;
}

export default function MapContent (props: Props) {

  return (
    <Box>
      <MapContainer ubication={props.ubication} height={props.height} width={props.width} zoom={props.zoom} />
    </Box>
  );
}